<template>
  <v-expansion-panels class="!wd-z-0" variant="accordion" multiple :model-value="defaultExpansionList">
    <v-expansion-panel v-for="faq in faqs" :key="faq.question" class="faq-expansion-panel">
      <v-expansion-panel-title class="wd-text-omd !wd-min-h-56px !wd-px-0 !wd-py-2 <xs:(!wd-py-3)" :class="headerClass" hide-actions>
        <template #default="{ expanded }">
          {{ faq.question }}
          <v-spacer />
          <v-btn class="!wd-px-0" :min-width="isMobile ? 32 : 40" :max-width="isMobile ? 32 : 40" :height="isMobile ? 32 : 40" variant="text">
            <funnow-icon :max-width="isMobile ? 20 : 24" :height="isMobile ? 20 : 24" :image-path="`chevron-${expanded ? 'up' : 'down'}.svg`" />
          </v-btn>
        </template>
      </v-expansion-panel-title>
      <v-expansion-panel-text class="faq-expansion-content" :class="contentClass">
        <p class="wd-text-omd wd-mt-4 !wd-mb-0" v-html="nl2br(faq.answer)" />
      </v-expansion-panel-text>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
// TODO: migrate with FAQ on branch page
import FunnowIcon from '@/components/icons/funnow-icon.vue'

import utils from '@/utils'
import { useVuetify } from '@/composition/useUtil'

export default defineComponent({
  name: 'QAndA',
  components: {
    FunnowIcon,
  },
  props: {
    defaultExpansionList: { type: Array, default: () => [] },
    faqs: { type: Array, default: () => [] },
    headerClass: { type: String, default: '' },
    contentClass: { type: String, default: '' },
  },
  setup() {
    const vuetify = useVuetify()
    const isMobile = computed(() => vuetify.display.xs.value)

    function nl2br(text) {
      return utils.nl2br(text)
    }

    return {
      isMobile,
      nl2br,
    }
  },
})
</script>

<style lang="scss">
.faq-expansion-panel:not(:last-child) {
  border-bottom: 1px solid $gray40;
}
.faq-expansion-content {
  .v-expansion-panel-content__wrap {
    padding-right: 0;
    padding-left: 0;
  }
}
</style>
